import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles(4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block text-xs font-label font-semibold tracking-widest uppercase text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full">
              精选文章
            </span>
            <h2 className="mt-4 text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              最新抗衰知识
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl">
              基于科学研究，为你精选最实用的抗衰老知识和方法
            </p>
          </div>
          <Link
            to="/category/kang-shuai-hu-fu"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}